import React, { useCallback, useEffect, useState } from "react";

import { withRouter, useHistory, useLocation } from "react-router-dom";
import { connect } from "react-redux";

import { Container } from "../../components/design/layout/container";
import { SearchField, SubmitSearch } from "../../components/design/layout/search";
import HeaderPage from "../../components/patterns/subpages/header";
import { fixedEncodeURIComponent } from '../../utils/fixedEncodeURIComponent';

import {
    Form,
    WrapperContent,
    SearchSuggestion,
    Title,
    Switch,
    Label,
    SwitchField,
    Mark,
    MostWanted,
    ResultItem,
    HiddenRadioField
} from "./styles";

import SearchTermsService from "../../services/SearchTerms";

import handleURLParams from '../../utils/handleURLParams';

function SearchPage({ website }) {

    const history = useHistory();
    const location = useLocation();

    // * States
    const [search, setSearch] = useState("");
    const [selectTypeSearch, setSelectTypeSearch] = useState('oferta');
    const [topSearch, setTopSearch] = useState([]);

    const searchKey = (e) => {
        e.preventDefault();

        const listOfKeyValues = [
            { key: 'key', value: fixedEncodeURIComponent(search) },
            { key: 'limit', value: 8 }
        ];

        if (selectTypeSearch === 'parceiro') {
            listOfKeyValues.push({ key: 'buscaParceiro', value: true })
        } else {
            listOfKeyValues.push({ key: 'buscaParceiro', value: false })
        }

        handleURLParams({
            listOfKeyValues,
            location: location,
            history: history
        });

        return history.push({ pathname: '/resultados', search: history.location.search });
    };

    const handleNewSearch = ({ term }) => {
        const listOfKeyValues = [
            { key: 'key', value: term },
            { key: 'limit', value: 8 }
        ];

        if (selectTypeSearch === 'parceiro') {
            listOfKeyValues.push({ key: 'buscaParceiro', value: true })
        } else {
            listOfKeyValues.push({ key: 'buscaParceiro', value: false })
        }

        handleURLParams({
            listOfKeyValues,
            location: location,
            history: history
        });
        return history.push({ pathname: '/resultados', search: history.location.search });
    }

    const handleTopSearch = useCallback(() => {
        const searchTermsService = new SearchTermsService();

        searchTermsService.listTop({ search_type: selectTypeSearch }).then((response) => {
            setTopSearch(response.data.payload);
        })
    }, [selectTypeSearch]);

    useEffect(() => {
        handleTopSearch();
    }, [handleTopSearch]);

    return (
        <>

            <HeaderPage>
                <Form onSubmit={(e) => searchKey(e)}>
                    <SearchField
                        placeholder={`Faça uma busca`}
                        type="text"
                        name="search"
                        onChange={(e) => setSearch(e.target.value)}
                    />

                    <SubmitSearch
                        searchIconColor={props => props.theme[website]?.pages.search.searchIcon}
                        searchText="Buscar"
                        type={search.length >= 2 ? "submit" : "button"}
                    />
                </Form>
            </HeaderPage>

            <WrapperContent>

                <Container withContainer={true} >

                    <SearchSuggestion>
                        <Title>Buscar por</Title>
                        <Switch>
                            <Label for="offers" switchButtonColor={props => props.theme[website]?.pages.search.button}>
                                <SwitchField
                                    type="radio"
                                    name="switch"
                                    id="offers"
                                    defaultChecked={true}
                                    onChange={(e) => setSelectTypeSearch('oferta')}
                                />
                                <Mark className="mark">Ofertas</Mark>
                            </Label>
                            <Label for="partners" switchButtonColor={props => props.theme[website]?.pages.search.button}>
                                <SwitchField
                                    type="radio"
                                    name="switch"
                                    id="partners"
                                    onChange={(e) => setSelectTypeSearch('parceiro')}
                                />
                                <Mark className="mark">Parceiros</Mark>
                            </Label>
                        </Switch>
                    </SearchSuggestion>

                    <SearchSuggestion>
                        <Title>Mais buscados</Title>

                        <MostWanted>
                            {topSearch && topSearch.map((item) => (
                                <ResultItem onClick={() => handleNewSearch({ term: item.termo })}>
                                    <HiddenRadioField
                                        type="radio"
                                        name="most_wanted"
                                    />
                                    <Mark className="mark">{item.termo && item.termo}</Mark>
                                </ResultItem>
                            ))}
                        </MostWanted>
                    </SearchSuggestion>

                </Container>

            </WrapperContent>
        </>
    )
}

const mapStateToProps = (state) => {
    return {
        scamber: state.scamberReducer.scamber,
        website: state.websiteReducer.website
    };
};

export default withRouter(connect(mapStateToProps)(SearchPage));